import React from 'react';
import ReportService from '../../Services/ReportService';
import ErrorMessage from '../ErrorMessage';
import ReportParamInputField from './ReportParamInputField';
import LoadingIcon from '../LoadingIcon';

export default class ReportFrameParameterBar extends React.Component {
  static defaultProps = {
    DynamicParams: false,
    reportName: null,
    clickOnViewReport: () => alert('clickOnViewReport is not set'),
    reportParams: {},
    hiddenParameters: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      parameters: [],
      parameterValues: {},
      barVisible: true,
    };
  }

  componentDidMount() {
    this.populateData(this.props.reportParams);
  }

  populateData(localParams) {
    this.setState({ loading: true });
    ReportService.GetReportParameters(localParams, this.props.reportName)
      .then((result) => this.onDataReceived(result))
      .catch((error) => this.onError(error));
  }

  onDataReceived(result) {
    this.setState({ loading: false });
    const tempParameterValues = {};
    if (result.error) {
      ErrorMessage.SetErrorMessage('RPB34', result.error);
      this.setState({
        parameters: [],
      });
      this.props.clickOnViewReport(this.props.reportParams);
      return;
    }
    result.forEach((parameter) => {
      let p =
        !parameter.defaultValues || parameter.defaultValues.length === 0 || parameter.defaultValues[0] === null
          ? ''
          : parameter.defaultValues;
      if (parameter.multiValue && Array.isArray(parameter.validValues) && Array.isArray(parameter.defaultValues)) {
        p = parameter.validValues.filter((item) => parameter.defaultValues.includes(item.value));
      }
      p = this.props.reportParams[parameter.name] || p;
      tempParameterValues[parameter.name] = p;
    });
    this.setState({
      parameters: result,
      parameterValues: tempParameterValues,
    });
    this.props.clickOnViewReport(tempParameterValues);
  }

  onError(error) {
    this.setState({ loading: false });
    ErrorMessage.SetErrorMessage('RPB56', error);
    this.setState({
      parameters: [],
    });
    this.props.clickOnViewReport(this.props.reportParams);
  }

  parameterValueOnChange(name, value) {
    const tempParameterValues = { ...this.state.parameterValues };
    tempParameterValues[name] = value;
    this.setState({ parameterValues: tempParameterValues }, () => {
      if (this.props.DynamicParams && this.props.DynamicParams.includes(name)) {
        this.populateData(this.state.parameterValues, this.props.reportName);
      }
    });
  }

  renderParameters() {
    return this.state.parameters.map((parameter, index) => {
      return (
        <ReportParamInputField
          parameter={parameter}
          value={this.state.parameterValues[parameter.name]}
          key={`param${index}`}
          onChange={this.parameterValueOnChange.bind(this)}
          disabled={this.props.reportParams.hasOwnProperty(parameter.name)}
          hidden={this.props.hiddenParameters && this.props.hiddenParameters.includes(parameter.name)}
        />
      );
    });
  }

  getVisible() {
    let numberOfEnabledParameters = 0;
    this.state.parameters.forEach((parameter) => {
      const disabled = this.props.reportParams.hasOwnProperty(parameter.name);
      numberOfEnabledParameters += disabled ? 0 : 1;
    });

    return numberOfEnabledParameters > 0;
  }

  renderLoading() {
    return (
      <div className='rf-param-bar'>
        <LoadingIcon loading={true} />
      </div>
    );
  }

  render() {
    if (!this.getVisible()) return null;
    if (this.state.loading) {
      return this.renderLoading();
    }
    return (
      <div className='rf-param-bar'>
        {this.renderParameters()}
        <button
          className='btn primary rf-param-cta'
          onClick={() => this.props.clickOnViewReport(this.state.parameterValues)}
        >
          View Report
          <i className='fa-solid fa-arrow-right' />
        </button>
      </div>
    );
  }
}
